import request from '@/lib/api'

const _BASE = "/free";
export function getIsAccessIndustry(id) {
  return request({
    url: `${_BASE}/industry/getKey`,
    method: 'get',
  })
}